export const CaptionStyle = {
  Highlighted: "highlighted",
  WordByWord: "wordByWord",
} as const;

export type HighlightWordProps = {
  text: string;
  isHighlighted: boolean;
  highlightColor: string;
  currentTime?: number;
  wordStart?: number;
};
